import cmp from './InfoPanel'

export default cmp
